KleoChildShow = function(el){
    el.style.display = "block";
};

KleoChildHide = function(el){
    el.style.display = "none";
};

KleoChildEnable = function(el){
    el.disabled = false;
};

KleoChildDisable = function(el){
    el.disabled = true;
};



KleoChildCheckCodiceFiscale = function (codiceFiscaleEl, errVuotoId, errMalformatoId, signupId){

    if(codiceFiscaleEl === null){
        return;
    }

    var errVuotoEl = document.getElementById(errVuotoId);
    var errMalformatoEl = document.getElementById(errMalformatoId);
//    var signupBtn = document.getElementById(signupId);

    if(codiceFiscaleEl.value.length === 0){
        KleoChildHide(errMalformatoEl);
        KleoChildShow(errVuotoEl);
//        KleoChildDisable(signupBtn);
        
        return;
    }

    // utilizzo il metodo search per verificare che il valore inserito nel campo
    // di input rispetti la stringa di verifica (pattern)
    if (!isValidCodiceFiscale(codiceFiscaleEl.value))
    {
        KleoChildShow(errMalformatoEl);
        KleoChildHide(errVuotoEl);
//        KleoChildDisable(signupBtn);
    }
    else
    {
        KleoChildHide(errMalformatoEl);
        KleoChildHide(errVuotoEl);
//        KleoChildCheckRegistrationForm() ? KleoChildEnable(signupBtn) : KleoChildDisable(signupBtn);
    }
};

KleoChildCheckEmail = function (emailEl, errVuotoId, errMalformatoId, signupId){

    if(emailEl === null){
        return;
    }

    var errVuotoEl = document.getElementById(errVuotoId);
    var errMalformatoEl = document.getElementById(errMalformatoId);
//    var signupBtn = document.getElementById(signupId);

    if(emailEl.value.length === 0){
        KleoChildHide(errMalformatoEl);
        KleoChildShow(errVuotoEl);
//        KleoChildDisable(signupBtn);
        
        return;
    }

    // utilizzo il metodo search per verificare che il valore inserito nel campo
    // di input rispetti la stringa di verifica (pattern)
    if (!isValidEmailAddress(emailEl.value))
    {
        KleoChildShow(errMalformatoEl);
        KleoChildHide(errVuotoEl);
//        KleoChildDisable(signupBtn);
    }
    else
    {
        KleoChildHide(errMalformatoEl);
        KleoChildHide(errVuotoEl);
//        KleoChildCheckRegistrationForm() ? KleoChildEnable(signupBtn) : KleoChildDisable(signupBtn);
    }
};

/*
 * justLeft = 1 significa che il focusout è stato fatto sul campo password, 2 sulla conferma
 */
KleoChildCheckPasswords = function (pw1ElId, pw2ElId, errVuoto1Id, errVuoto2Id, errMalformatoId, signupId, justLeft){

    var pw1El = document.getElementById(pw1ElId);
    var pw2El = document.getElementById(pw2ElId);
    var errVuoto1El = document.getElementById(errVuoto1Id);
    var errVuoto2El = document.getElementById(errVuoto2Id);
    var errMalformatoEl = document.getElementById(errMalformatoId);
//    var signupBtn = document.getElementById(signupId);

    var oneEmpty = false;

    if(justLeft == 1 && pw1El.value.length === 0){
        KleoChildHide(errMalformatoEl);
        KleoChildShow(errVuoto1El);
//        KleoChildDisable(signupBtn);
        oneEmpty = true;
    }

    if(justLeft == 2 && pw2El.value.length === 0){
        KleoChildHide(errMalformatoEl);
        KleoChildShow(errVuoto2El);
//        KleoChildDisable(signupBtn);
        oneEmpty = true;
    }
    
    if(oneEmpty){
        return;
    }

    // utilizzo il metodo search per verificare che il valore inserito nel campo
    // di input rispetti la stringa di verifica (pattern)
    if (pw1El.value.length != 0 && pw2El.value.length != 0 && pw2El.value !== pw1El.value)
    {
        KleoChildShow(errMalformatoEl);
        KleoChildHide(errVuoto1El);
        KleoChildHide(errVuoto2El);
//        KleoChildDisable(signupBtn);
    }
    else
    {
        KleoChildHide(errMalformatoEl);
        KleoChildHide(errVuoto1El);
        KleoChildHide(errVuoto2El);
//        KleoChildCheckRegistrationForm() ? KleoChildEnable(signupBtn) : KleoChildDisable(signupBtn);
    }
};

KleoChildCheckYesNo = function (radioYesId, radioNoId, errId, signupId){
    var radioYes = document.getElementById(radioYesId);
    var radioNo = document.getElementById(radioNoId);
    var errEl = document.getElementById(errId);
//    var signupBtn = document.getElementById(signupId);
    
    if(radioYes.checked && !radioNo.checked){
        //ok
        KleoChildHide(errEl);
//        KleoChildCheckRegistrationForm() ? KleoChildEnable(signupBtn) : KleoChildDisable(signupBtn);
    }
    else{
        //no
        KleoChildShow(errEl);
//        KleoChildDisable(signupBtn);
    }
};

KleoChildCheckCampoObbligatorio = function (campo, errVuotoId, signupId){
    
    if(campo === null){
        return;
    }
    
    var errVuotoEl = document.getElementById(errVuotoId);
//    var signupBtn = document.getElementById(signupId);
    
    if(campo.value.length === 0){
        KleoChildShow(errVuotoEl);
//        KleoChildDisable(signupBtn);
    }
    else{
        KleoChildHide(errVuotoEl);
//        KleoChildCheckRegistrationForm() ? KleoChildEnable(signupBtn) : KleoChildDisable(signupBtn);
    }
};

KleoChildCheckRegistrationForm = function(){
    var usernameEl  = document.getElementById("signup_username");
    var emailEl     = document.getElementById("signup_email");
    var pwd1El      = document.getElementById("signup_password");
    var pwd2El      = document.getElementById("signup_password_confirm");
    
    var nomeEl      = document.getElementById("field_1");
    var cognomeEl   = document.getElementById("field_2");
    var codfEl      = document.getElementById("field_3");
    
    var telEl      = document.getElementById("field_4");
    var datanEl      = document.getElementById("field_5");
    var datandpEl      = document.getElementById("field_5-dp");
    var luogonEl      = document.getElementById("field_6");
    
    var sessoDonna      = document.getElementById("option_8");
    var sessoUomo      = document.getElementById("option_9");
    
    var regYes      = document.getElementById("regolamento_si");
    var regNo       = document.getElementById("regolamento_no");
    
    var privYes     = document.getElementById("privacy_si");
    var privNo      = document.getElementById("privacy_no");
    
    if(usernameEl.value.length == 0) return false;
    if(emailEl.value.length == 0) return false;
    if(pwd1El.value.length == 0) return false;
    if(pwd2El.value.length == 0) return false;
    
    if(nomeEl.value.length == 0) return false;
    if(cognomeEl.value.length == 0) return false;
    if(codfEl.value.length == 0) return false;
    
    if(telEl.value.length == 0) return false;
    if(datanEl.value.length == 0 && datandpEl.value.length == 0) return false;
    if(luogonEl.value.length == 0) return false;
    
    if(!(sessoDonna.checked  && !sessoUomo.checked))  return false;
    
    if(!isValidEmailAddress(emailEl.value)) return false;
    if(!isValidCodiceFiscale(codfEl.value)) return false;
    if(pwd1El.value != pwd2El.value) return false;
    
    if(!(regYes.checked  && !regNo.checked))  return false;
    if(!(privYes.checked && !privNo.checked)) return false;
    
    return true;
};


KleoChildCopyDate = function(srcId, dstId){
        
    var $src = jQuery(srcId);
    var $dst = jQuery(dstId);

    var str = $src.val();
    var parts = str.split("/");
    var d = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    var y = parseInt(parts[2], 10);
    var str2 = y + "-" + m + "-" + d;
    $dst.val(str2);
    
    console.log("copio date: "+str+" diventa "+str2);

};